import { Box, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAButton from "../config/components/BAButton";
import BAGrid from "../config/components/BAGrid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Delete, Get } from "../config/apimethods/apimethods";
import BAIconbutton from "../config/components/BAIconbutton";
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

export default function Estimate() {
    const [loader, setLoader] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [message, setMessage] = useState()
    const [listData, setListData] = useState([])
    const [delId, setDelId] = useState()

    const navigate = useNavigate()
    const addEdit = (id) => {
        navigate(`/estimateform/${id ? id : ''}`)
    }

    const getData = () => {
        setLoader(true)
        Get('estimate').then(res => {
            setLoader(false)
            console.log(res)
            if (res.status) {
                setListData(res.data)
            } else {
                setMessage(res.errors)
                setShowMessage(true)
            }
        }).catch(err => {
            setLoader(false)
            console.log(err)
        })
    }
    const delEstimate = (id) => {
        Delete('estimate', id).then(res => {
            setShowMessage(true)
            setMessage("Estimate Deleted Successfully")
            getData()
        }).catch(err => {
            setShowMessage(true)
            setMessage("Estimate Deleted Successfully")
        })
    }

    useEffect(() => {
        getData()
    }, [])


    let printEstimate = (e) => {
        navigate("/printestimate", { state: { model: e } });
    };

    return <>
        <Box>
            <BAScreenHeader title='Estimate' buttonsList={[
                {
                    displayField: <BAButton onClick={() => addEdit()} label='Add Estimate' />
                }
            ]} />
            <Box>
                <BAGrid datasource={listData} gridCols={[
                    {
                        key: 'del',
                        label: 'Delete',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => delEstimate(e._id)} color='error' icon={<DeleteIcon />} />
                    },
                    {
                        key: 'edit',
                        label: 'Edit',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => addEdit(e._id)} icon={<EditIcon />} />
                    },
                    {
                        key: 'view',
                        label: 'View',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton icon={<RemoveRedEyeIcon />} />
                    },
                    {
                        key: 'print',
                        label: 'Print',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => printEstimate(e)} icon={<PrintIcon />} />
                    },
                    {
                        key: 'customerName',
                        label: 'Customer Name'
                    },
                    {
                        key: 'companyName',
                        label: 'Company'
                    },
                    {
                        key: 'totalAmount',
                        label: 'Total Amount'
                    },
                    {
                        key: 'installationCharges',
                        label: 'Installation Charges'
                    },
                ]} loading={loader} />
            </Box>
        </Box>
    </>
}